import { SfxId } from '@/sfx';
import { AXE_SWEEP_FRAMES, BAZAR_AXE_SWEEP } from '@/render/axe-sweep';

export enum EffectAnimationType {
  Static = 0,
  VerticalSliding = 1,
  Position = 2,
  Flickering = 3,
}

type VerticalSlidingEffectMetadata = {
  frameOffsetY: number;
};

type PositionOffsetEffectMetadata = {
  offsetByFrameX: number[];
  offsetByFrameY: number[];
};

type RandomFlickeringEffectMetadata = {
  firstFrame: number;
  lastFrame: number;
};

export class EffectMetadata {
  constructor(
    public hasBehindLayer: boolean,
    public hasTransparentLayer: boolean,
    public hasInFrontLayer: boolean,
    public sfx: number,
    public frames: number,
    public loops: number,
    public offsetX: number,
    public offsetY: number,
    public animationType: EffectAnimationType,
    public verticalMetadata: VerticalSlidingEffectMetadata | null,
    public positionOffsetMetadata: PositionOffsetEffectMetadata | null,
    public randomFlickeringMetadata: RandomFlickeringEffectMetadata | null,
  ) {}
}

export function getEffectMetaData(): Map<number, EffectMetadata> {
  return new Map([
    [BAZAR_AXE_SWEEP, new EffectMetadata(false, false, false, 0, AXE_SWEEP_FRAMES, 1, 0, 0, EffectAnimationType.Static, null, null, null)],
    [35, new EffectMetadata(false, false, true, 0, 17, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // holy-00-1
    [36, new EffectMetadata(false, false, true, 0, 15, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // holy-00-2
    [37, new EffectMetadata(false, false, true, 0, 18, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // holy-00-3
    [38, new EffectMetadata(false, false, true, 0, 7, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // holy-01-1
    [39, new EffectMetadata(false, false, true, 0, 7, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // holy-01-2
    [40, new EffectMetadata(false, false, true, 0, 8, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // holy-01-3
    [41, new EffectMetadata(false, false, true, 0, 9, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // holy-01-4
    [42, new EffectMetadata(false, false, true, 0, 9, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // holy-01-5
    [43, new EffectMetadata(false, false, true, 0, 9, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // holy-01-6
    [44, new EffectMetadata(false, false, true, 0, 9, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // holy-01-7
    [45, new EffectMetadata(false, false, true, 0, 10, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // holy-01-8
    [46, new EffectMetadata(false, false, true, 0, 11, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // holy-01-9
    [47, new EffectMetadata(false, false, true, 0, 9, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro1-01
    [48, new EffectMetadata(false, false, true, 0, 9, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro1-05
    [49, new EffectMetadata(false, false, true, 0, 9, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro1-08
    [50, new EffectMetadata(false, false, true, 0, 9, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro1-10
    [51, new EffectMetadata(false, false, true, 0, 9, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro1-12
    [52, new EffectMetadata(false, false, true, 0, 10, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro1-13
    [53, new EffectMetadata(false, false, true, 0, 10, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro1-20
    [54, new EffectMetadata(false, false, true, 0, 10, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro1-21
    [55, new EffectMetadata(false, false, true, 0, 10, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro1-22
    [56, new EffectMetadata(false, false, true, 0, 11, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro1-29
    [57, new EffectMetadata(false, false, true, 0, 11, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro1-31
    [58, new EffectMetadata(false, false, true, 0, 11, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro1-36
    [59, new EffectMetadata(false, false, true, 0, 11, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro1-38
    [60, new EffectMetadata(false, false, true, 0, 11, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro1-42
    [61, new EffectMetadata(false, false, true, 0, 11, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro1-44
    [62, new EffectMetadata(false, false, true, 0, 12, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro1-47
    [63, new EffectMetadata(false, false, true, 0, 12, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro1-52
    [64, new EffectMetadata(false, false, true, 0, 12, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro1-54
    [65, new EffectMetadata(false, false, true, 0, 12, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro1-55
    [66, new EffectMetadata(false, false, true, 0, 12, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro1-56
    [67, new EffectMetadata(false, false, true, 0, 8, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-01
    [68, new EffectMetadata(false, false, true, 0, 10, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-02
    [69, new EffectMetadata(false, false, true, 0, 11, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-03
    [70, new EffectMetadata(false, false, true, 0, 12, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-04
    [71, new EffectMetadata(false, false, true, 0, 11, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-05
    [72, new EffectMetadata(false, false, true, 0, 10, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-06
    [73, new EffectMetadata(false, false, true, 0, 11, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-07
    [74, new EffectMetadata(false, false, true, 0, 12, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-08
    [75, new EffectMetadata(false, false, true, 0, 9, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-09
    [76, new EffectMetadata(false, false, true, 0, 11, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-10
    [77, new EffectMetadata(false, false, true, 0, 10, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-11
    [78, new EffectMetadata(false, false, true, 0, 12, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-12
    [79, new EffectMetadata(false, false, true, 0, 12, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-13
    [80, new EffectMetadata(false, false, true, 0, 11, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-14
    [81, new EffectMetadata(false, false, true, 0, 10, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-15
    [82, new EffectMetadata(false, false, true, 0, 11, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-16
    [83, new EffectMetadata(false, false, true, 0, 12, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-17
    [84, new EffectMetadata(false, false, true, 0, 10, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-18
    [85, new EffectMetadata(false, false, true, 0, 10, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-19
    [86, new EffectMetadata(false, false, true, 0, 12, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-20
    [87, new EffectMetadata(false, false, true, 0, 10, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-21
    [88, new EffectMetadata(false, false, true, 0, 11, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-22
    [89, new EffectMetadata(false, false, true, 0, 12, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-23
    [90, new EffectMetadata(false, false, true, 0, 10, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-24
    [91, new EffectMetadata(false, false, true, 0, 12, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-25
    [92, new EffectMetadata(false, false, true, 0, 10, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-26
    [93, new EffectMetadata(false, false, true, 0, 12, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-27
    [94, new EffectMetadata(false, false, true, 0, 10, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-28
    [95, new EffectMetadata(false, false, true, 0, 9, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-29
    [96, new EffectMetadata(false, false, true, 0, 12, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-30
    [97, new EffectMetadata(false, false, true, 0, 12, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-31
    [98, new EffectMetadata(false, false, true, 0, 11, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-32
    [99, new EffectMetadata(false, false, true, 0, 10, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-33
    [100, new EffectMetadata(false, false, true, 0, 10, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-34
    [101, new EffectMetadata(false, false, true, 0, 10, 1, 0, 0, EffectAnimationType.Static, null, null, null)], // retro2-35
    [
      1,
      new EffectMetadata(
        true,
        true,
        true,
        SfxId.PotionOfFlamesEffect,
        4,
        2,
        0,
        0,
        EffectAnimationType.Static,
        null,
        null,
        null,
      ),
    ], // small fire
    [
      2,
      new EffectMetadata(
        false,
        false,
        true,
        SfxId.PotionOfLoveEffect,
        4,
        4,
        0,
        0,
        EffectAnimationType.Static,
        null,
        null,
        null,
      ),
    ], // hearts
    [
      3,
      new EffectMetadata(
        false,
        true,
        true,
        SfxId.AdminWarp,
        8,
        1,
        0,
        0,
        EffectAnimationType.Static,
        null,
        null,
        null,
      ),
    ], // admin warp
    [
      4,
      new EffectMetadata(
        false,
        false,
        true,
        SfxId.AdminWarp,
        8,
        1,
        0,
        0,
        EffectAnimationType.Static,
        null,
        null,
        null,
      ),
    ], // admin warp 2
    [
      5,
      new EffectMetadata(
        false,
        false,
        true,
        SfxId.PotionOfFireworksEffect,
        7,
        2,
        0,
        0,
        EffectAnimationType.Static,
        null,
        null,
        null,
      ),
    ], // celebrate
    [
      6,
      new EffectMetadata(
        false,
        true,
        true,
        SfxId.PotionOfSparklesEffect,
        5,
        1,
        0,
        0,
        EffectAnimationType.Static,
        null,
        null,
        null,
      ),
    ], // schwing
    [
      7,
      new EffectMetadata(
        true,
        false,
        false,
        SfxId.PotionOfEvilTerrorEffect,
        4,
        4,
        0,
        0,
        EffectAnimationType.Static,
        null,
        null,
        null,
      ),
    ], // evil
    [
      8,
      new EffectMetadata(
        true,
        false,
        false,
        SfxId.PotionOfEvilTerrorEffect,
        4,
        4,
        0,
        0,
        EffectAnimationType.Static,
        null,
        null,
        null,
      ),
    ], // terror
    [
      9,
      new EffectMetadata(
        true,
        false,
        false,
        SfxId.Water,
        6,
        1,
        0,
        0,
        EffectAnimationType.Static,
        null,
        null,
        null,
      ),
    ], // water splash
    [
      10,
      new EffectMetadata(
        false,
        true,
        true,
        SfxId.Heal,
        5,
        1,
        0,
        0,
        EffectAnimationType.Static,
        null,
        null,
        null,
      ),
    ], // heal
    [
      11,
      new EffectMetadata(
        false,
        false,
        true,
        SfxId.Thunder,
        4,
        2,
        0,
        0,
        EffectAnimationType.Static,
        null,
        null,
        null,
      ),
    ], // small thunder
    [
      12,
      new EffectMetadata(
        false,
        false,
        true,
        0,
        4,
        8,
        0,
        0,
        EffectAnimationType.Static,
        null,
        null,
        null,
      ),
    ], // snow
    [
      13,
      new EffectMetadata(
        true,
        true,
        false,
        SfxId.UltimaBlastSpell,
        4,
        3,
        0,
        0,
        EffectAnimationType.Static,
        null,
        null,
        null,
      ),
    ], // ultima
    [
      14,
      new EffectMetadata(
        true,
        true,
        false,
        SfxId.PotionOfFlamesEffect,
        6,
        1,
        0,
        -160,
        EffectAnimationType.VerticalSliding,
        { frameOffsetY: 30 },
        null,
        null,
      ),
    ], // fire ball
    [
      15,
      new EffectMetadata(
        false,
        true,
        true,
        SfxId.ShieldSpell,
        6,
        1,
        0,
        0,
        EffectAnimationType.Static,
        null,
        null,
        null,
      ),
    ], // shield
    [
      16,
      new EffectMetadata(
        true,
        false,
        true,
        SfxId.RingOfFireSpell,
        4,
        3,
        0,
        0,
        EffectAnimationType.Static,
        null,
        null,
        null,
      ),
    ], // ring of fire
    [
      17,
      new EffectMetadata(
        false,
        true,
        true,
        SfxId.IceBlastSpell1,
        7,
        1,
        0,
        0,
        EffectAnimationType.Static,
        null,
        null,
        null,
      ),
    ], // ice blast
    [
      18,
      new EffectMetadata(
        false,
        false,
        true,
        SfxId.EnergyBallSpell,
        7,
        1,
        0,
        0,
        EffectAnimationType.VerticalSliding,
        { frameOffsetY: -10 },
        null,
        null,
      ),
    ], // energy ball
    [
      19,
      new EffectMetadata(
        true,
        true,
        true,
        SfxId.WhirlSpell,
        4,
        2,
        0,
        -10,
        EffectAnimationType.Position,
        null,
        { offsetByFrameX: [-20, 0, 20, 0], offsetByFrameY: [0, 14, 0, -14] },
        null,
      ),
    ], // whirl / tornado
    [
      20,
      new EffectMetadata(
        false,
        true,
        false,
        SfxId.AuraSpell,
        5,
        3,
        0,
        -12,
        EffectAnimationType.Flickering,
        null,
        null,
        { firstFrame: 3, lastFrame: 4 },
      ),
    ], // aura
    [
      21,
      new EffectMetadata(
        false,
        false,
        true,
        SfxId.BouldersSpell,
        7,
        1,
        0,
        -160,
        EffectAnimationType.VerticalSliding,
        { frameOffsetY: 30 },
        null,
        null,
      ),
    ], // boulders
    [
      22,
      new EffectMetadata(
        true,
        true,
        false,
        SfxId.HeavenSpell,
        5,
        4,
        0,
        -114,
        EffectAnimationType.Flickering,
        null,
        null,
        { firstFrame: 3, lastFrame: 4 },
      ),
    ], // heaven
    [
      23,
      new EffectMetadata(
        true,
        true,
        false,
        SfxId.IceBlastSpell2,
        6,
        1,
        0,
        -160,
        EffectAnimationType.VerticalSliding,
        { frameOffsetY: 30 },
        null,
        null,
      ),
    ], // blue flame
    [
      24,
      new EffectMetadata(
        true,
        true,
        false,
        SfxId.HeavenSpell,
        5,
        4,
        0,
        -114,
        EffectAnimationType.Flickering,
        null,
        null,
        { firstFrame: 3, lastFrame: 4 },
      ),
    ], // dark beam
    [
      25,
      new EffectMetadata(
        false,
        false,
        true,
        SfxId.AdminHide,
        4,
        2,
        0,
        0,
        EffectAnimationType.Static,
        null,
        null,
        null,
      ),
    ], // admin hide
    [
      26,
      new EffectMetadata(
        true,
        true,
        false,
        SfxId.DarkHandSpell,
        5,
        2,
        0,
        0,
        EffectAnimationType.Static,
        null,
        null,
        null,
      ),
    ], // dark hand
    [
      27,
      new EffectMetadata(
        true,
        true,
        false,
        SfxId.DarkHandSpell,
        5,
        2,
        0,
        0,
        EffectAnimationType.Static,
        null,
        null,
        null,
      ),
    ], // dark skull
    [
      28,
      new EffectMetadata(
        false,
        false,
        true,
        SfxId.FireBlastSpell,
        4,
        1,
        0,
        0,
        EffectAnimationType.Static,
        null,
        null,
        null,
      ),
    ], // fire blast
    [
      29,
      new EffectMetadata(
        false,
        false,
        true,
        SfxId.TentaclesSpell,
        5,
        2,
        0,
        0,
        EffectAnimationType.Static,
        null,
        null,
        null,
      ),
    ], // tentacles
    [
      30,
      new EffectMetadata(
        true,
        false,
        true,
        SfxId.PowerWindSpell,
        6,
        2,
        0,
        0,
        EffectAnimationType.Static,
        null,
        null,
        null,
      ),
    ], // power wind
    [
      31,
      new EffectMetadata(
        true,
        false,
        true,
        SfxId.MagicWhirlSpell,
        15,
        1,
        0,
        0,
        EffectAnimationType.Static,
        null,
        null,
        null,
      ),
    ], // magic whirl
    [
      32,
      new EffectMetadata(
        true,
        true,
        false,
        SfxId.DarkHandSpell,
        6,
        2,
        0,
        0,
        EffectAnimationType.Static,
        null,
        null,
        null,
      ),
    ], // dark bite
    [
      33,
      new EffectMetadata(
        true,
        true,
        false,
        SfxId.AuraSpell,
        4,
        4,
        0,
        0,
        EffectAnimationType.Static,
        null,
        null,
        null,
      ),
    ], // shell
    [
      34,
      new EffectMetadata(
        true,
        true,
        false,
        SfxId.EnergyBallSpell,
        5,
        1,
        0,
        -44,
        EffectAnimationType.Static,
        null,
        null,
        null,
      ),
    ], // green flame
  ]);
}
